/**
 * Remembers that the session ended on its own: the API answered 401 and the
 * silent refresh (lib/sessionRefresh.ts) could not renew it. apiClient marks
 * it; AuthProvider subscribes and signs the user out (ProtectedRoute then shows
 * the login page), and LoginPage shows "Your session has expired". The flag
 * lasts for the page session and is cleared by the next successful login.
 */
type Listener = () => void;

let sessionExpired = false;
const listeners = new Set<Listener>();

export function markSessionExpired(): void {
  if (sessionExpired) return;
  sessionExpired = true;
  listeners.forEach((listener) => listener());
}

export function isSessionExpired(): boolean {
  return sessionExpired;
}

export function clearSessionExpired(): void {
  if (!sessionExpired) return;
  sessionExpired = false;
  listeners.forEach((listener) => listener());
}

export function subscribeSessionExpired(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
